import PanelGroupBlock from 'blocks/PanelGroup/index';
import styled from 'styled-components';

import StyledPanelHeading from './StyledPanelHeading';
import StyledPanelBody from './StyledPanelBody';
import StyledPanelTitle from './StyledPanelTitle';
import TitleText from './TitleText';
import Arrow from './Arrow';


const PanelGroup = styled(PanelGroupBlock)``;

PanelGroup.Panel = PanelGroupBlock.Panel;
PanelGroup.Heading = StyledPanelHeading;

PanelGroup.Title = StyledPanelTitle;
PanelGroup.TitleText = TitleText;
PanelGroup.Body = StyledPanelBody;
PanelGroup.Arrow = Arrow;

export default PanelGroup;



// WEBPACK FOOTER //
// ./src/kentico-blocks/Accordion/PanelGroup/index.jsx